import { IImage } from "../types";
import { IDeviceGraphic } from "../types/deviceGraphic.types";
import { getImage } from "../utils";

export function deviceGraphicProxy(component: any): IDeviceGraphic {

    const title = component?.fields?.title;
    const componentType = component?.fields?.componentType;
    const description = component?.fields?.description;

    let image = {} as IImage;
    component?.fields?.entries?.forEach(({ fields, sys }: any) => {
        if (sys?.contentType?.sys?.id === 'AdaptiveImage') {
            image = getImage({ fields });
        }
    });


    return {
        title,
        componentType,
        description,
        image
    };
};
